// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5429":"cd446b50","8428":"cd446b50"}[chunkId] + ".chunk.css";
};